<mat-card>
  <mat-card-title>Giorno {{ dayId + 1 }}</mat-card-title>
  <mat-card-subtitle>{{
    day.date?.toDate() | date: "d MMMM, EEEE"
  }}</mat-card-subtitle>
  <app-itinerary-day-info-form
    [day]="day"
    [dayId]="dayId"
  ></app-itinerary-day-info-form>
</mat-card>
